<h3 mat-dialog-title>⚠️ ATENÇÃO</h3>
<div mat-dialog-content>
  <p>{{mensagem}}</p>
  <mat-radio-group [formControl]="acao">
    <div>
      <mat-radio-button [value]="acaoLevar">{{textoLevar}}</mat-radio-button>
    </div>
    <div>
      <mat-radio-button [value]="acaoCancelar">{{textoCancelar}}</mat-radio-button>
    </div>
  </mat-radio-group>
</div>
<div mat-dialog-actions class="md-toolbar-tools">
  <div class="row">
    <div class="col-md-6 no">
      <button mat-raised-button color="warn" (click)="fechar()">Não substituir</button>
    </div>
    <div class="col-md-6 yes">
      <button mat-raised-button color="primary" (click)="confirmar()" [disabled]="acao.invalid">Substituir</button>
    </div>
  </div>
</div>
